var map = {
	"./load-1-1.png": "827f",
	"./load-1-2.png": "8801",
	"./load-1-3.png": "963b",
	"./load-2-1.png": "b8f1",
	"./load-2-2.png": "ec1e",
	"./load-2-3.png": "7f30",
	"./load-3-1.png": "c15b",
	"./load-3-2.png": "0d93",
	"./load-3-3.png": "f48b",
	"./load-4-1.png": "286f",
	"./load-4-2.png": "a55a",
	"./load-4-3.png": "e2ec",
	"./load-5-1.png": "f128",
	"./load-5-2.png": "00f9",
	"./load-5-3.png": "53f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f623";